import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createSlots as _createSlots, createBlock as _createBlock } from "vue";
const _hoisted_1 = { class: "more-box__qty" };
const _hoisted_2 = { class: "filt-box__top" };
const _hoisted_3 = { class: "form-group" };
const _hoisted_4 = { class: "form-field form-field--text form-field--3 form-field--s form-field--primary" };
const _hoisted_5 = { class: "form-field__side form-field__side--left" };
const _hoisted_6 = ["placeholder"];
import { ref, watch } from 'vue';
import ItemWrapper from './ItemWrapper.vue';
import Icon from '../../../components/Icon.vue';
import Sprite from "../../../components/Sprite.vue";
export default /*@__PURE__*/ _defineComponent({
    __name: 'TextInputItem',
    props: {
        item: { type: Object, required: true },
    },
    emits: ["update"],
    setup(__props, { emit: __emit }) {
        const props = __props;
        const emit = __emit;
        const inputRef = ref(null);
        const textValue = ref(props.item.value || '');
        const isFocused = ref(false);
        let debounceTimer = null;
        function onInput() {
            const hasText = textValue.value.trim().length > 0;
            props.item.value = textValue.value;
            props.item.active = textValue.value.trim().length > 0;
            props.item.count = hasText ? 1 : 0;
            if (debounceTimer)
                clearTimeout(debounceTimer);
            debounceTimer = setTimeout(() => {
                emit('update', true);
            }, 350);
        }
        function onBlur() {
            isFocused.value = false;
            props.item.value = textValue.value;
            props.item.active = textValue.value.trim().length > 0;
        }
        function reset() {
            textValue.value = '';
            props.item.value = '';
            props.item.active = false;
            props.item.count = 0;
            isFocused.value = false;
            if (debounceTimer)
                clearTimeout(debounceTimer);
            emit('update', false);
            inputRef.value?.focus();
        }
        // Синхронизируем значение из стора ТОЛЬКО если пользователь прямо сейчас не печатает в поле
        watch(() => props.item.value, (val) => {
            if (!isFocused.value) {
                textValue.value = val || '';
            }
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createBlock(ItemWrapper, {
                item: __props.item,
                noResetButton: "",
                onReset: reset
            }, _createSlots({
                body: _withCtx(() => [
                    _createElementVNode("div", _hoisted_2, [
                        _createElementVNode("div", _hoisted_3, [
                            _createElementVNode("div", _hoisted_4, [
                                _createElementVNode("div", _hoisted_5, [
                                    _createVNode(Icon, {
                                        name: "search",
                                        "class-name": "form-icon"
                                    })
                                ]),
                                _cache[3] || (_cache[3] = _createTextVNode()),
                                _withDirectives(_createElementVNode("input", {
                                    ref_key: "inputRef",
                                    ref: inputRef,
                                    type: "text",
                                    class: "form-control",
                                    placeholder: __props.item.placeholder,
                                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((textValue).value = $event)),
                                    onInput: onInput,
                                    onFocus: _cache[1] || (_cache[1] = ($event) => (isFocused.value = true)),
                                    onBlur: onBlur
                                }, null, 40 /* PROPS, NEED_HYDRATION */, _hoisted_6), [
                                    [_vModelText, textValue.value]
                                ]),
                                _cache[4] || (_cache[4] = _createTextVNode()),
                                (textValue.value)
                                    ? (_openBlock(), _createElementBlock("button", {
                                        key: 0,
                                        type: "button",
                                        class: "btn btn--4 btn--m btn--gray btn--icon",
                                        onMousedown: _cache[2] || (_cache[2] = _withModifiers(() => { }, ["prevent"])),
                                        onClick: reset
                                    }, [
                                        _createVNode(Sprite, { name: "cross" })
                                    ], 32 /* NEED_HYDRATION */))
                                    : _createCommentVNode("v-if", true)
                            ])
                        ])
                    ])
                ]),
                _: 2 /* DYNAMIC */
            }, [
                (__props.item.active)
                    ? {
                        name: "badge",
                        fn: _withCtx(() => [
                            _createElementVNode("span", _hoisted_1, _toDisplayString(__props.item.count), 1 /* TEXT */)
                        ]),
                        key: "0"
                    }
                    : undefined
            ]), 1032 /* PROPS, DYNAMIC_SLOTS */, ["item"]));
        };
    }
});
